import React, { Component } from "react";
import PropTypes from "prop-types";
import Header from "../components/Header.js";
import icon_sign from "../images/icone-doc-assinado.svg";
import iconPendencia from "../images/icone-doc-assinado-pendencia.png";
import Footer from "../components/Footer/Footer.js";
import RedirectAuthenticate from "../components/RedirectAuthenticate.js";
export class DocumentSigned extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageSuccesSign: true,
    };
  }

  redirect = () => {
    window.location.replace(`${window.location.origin}/?docs=${this.props.identifier}`);
  };

  render() {
    return (
      <div className="container h-100">
        <Header logo={this.props.logo} />
        <div className="row text-center px-4" style={{ minHeight: "calc(100vh - 106px)" }}>
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-8 offset-xl-2 mt-5">
            {!this.state.pageSuccesSign && !this.props.exibDownload && (
              <>
                <span>
                  <br></br>
                  <img src={iconPendencia} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block" />
                  <h1 className="card-title fw-bold mt-3 text-white">SUA ASSINATURA FOI CONCLUÍDA</h1>
                  <h1 className="card-title fw-bold mt-3 text-danger">MAS FALTAM ASSINATURAS DE OUTRAS PESSOAS</h1>
                  <h5 className="card-text text-light mt-3">Você será avisado logo que todos assinarem.</h5>
                </span>
              </>
            )}

            {this.state.pageSuccesSign && this.props.urlRedirect && (
              <>
                <img src={icon_sign} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block" />
                <h1 className="card-title fw-bold text-white mt-3 mb-2">DOCUMENTO ASSINADO COM SUCESSO</h1>

                <h5 className="card-text text-light">NOSSO PROCESSO É BASTANTE SEGURO</h5>
                <h5 className="card-text text-light">NINGUÉM ASSINA POR VOCÊ.</h5>
                {this.props.urlRedirect ? <RedirectAuthenticate urlRedirect={this.props.urlRedirect} /> : window.opener ? this.verifyPopUp() : ""}
              </>
            )}
            {this.state.pageSuccesSign && !this.props.urlRedirect && (
              <>
                <img src={icon_sign} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block" />
                <h1 className="card-title fw-bold text-white mt-3 mb-2">DOCUMENTO ASSINADO COM SUCESSO</h1>

                <h5 className="card-text text-light">NOSSO PROCESSO É BASTANTE SEGURO</h5>
                <h5 className="card-text text-light">NINGUÉM ASSINA POR VOCÊ.</h5>
                <p className="card-text text-light mt-2 mb-4">
                  CLIQUE NO BOTÃO ABAIXO <br /> PARA GUARDAR O DOCUMENTO
                </p>
                <div className="row mt-5 justify-content-center">
                  <div className="col-8 d-grid">
                    {this.props.exibDownload ? (
                      <button className="btn btn-primary fw-bold" type="button" onClick={() => this.redirect()}>
                        BAIXAR DOCUMENTO
                      </button>
                    ) : (
                      <button className="btn btn-primary fw-bold" type="button" onClick={() => this.setState({ pageSuccesSign: false })}>
                        BAIXAR DOCUMENTO
                      </button>
                    )}
                  </div>
                </div>
              </>
            )}
            <div className="mt-5">
              <Footer />
            </div>
          </div>
        </div>
      </div>
    );
  }
  verifyPopUp() {
    window.opener.postMessage([true, this.props.keyCallback], "*");
    window.close();
  }
}

DocumentSigned.propTypes = {
  exibDownload: PropTypes.bool,
  identifier: PropTypes.string.isRequired,
  urlRedirect: PropTypes.string,
  keyCallback: PropTypes.string,
};

export default DocumentSigned;
